module.exports = __webpack_public_path__ + "media/images/default/shared/header/logo-white-258c296a2f7c03640acdaf9c08eafd0d.svg";